import GlobalTypes from "./GlobalTypes";
import { postDataAPI } from "../../utils/API";
import { dialog } from "../../component/Common/TreasuryDialog";
import axios from "axios";

export const PROPERTY_TYPES = {
	LOADING: "LOADING",
	CREATE_PROPERTY: "CREATE_PROPERTY",
	GET_PROPERTY: "GET_PROPERTY",
	ID: "ID",
	GET_COMPLETED: "GET_COMPLETED",
	GET_PROFILE: "GET_PROFILE",
	DEPLOY: "DEPLOY",
	CONTRACT_DETAIL: "CONTRACT_DETAIL",
};

export const createProperty = (data, images, deed) => async (dispatch, getState) => {
	try {
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: true } });
		const token = getState().auth?.data?.accesstoken || getState().auth?.data?.access_token;
		const res = await postDataAPI("create_property", data, token);
		if(res.data.status==1){
			const propertyId = res.data.Property._id;
			// Only upload if there are images or a deed file
			if ((images && images.length > 0) || deed) {
				var formData = new FormData();
				formData.append("propertyId", propertyId);
				if (images && images.length > 0) {
					images.forEach(img => formData.append("images", img));
				}
				if (deed) {
					formData.append("deed", deed);
				}
				try {
					const resp = await axios.post("/api/upload", formData, {
						headers: {
							"content-type": "multipart/form-data",
							"Authorization": `Bearer ${token}`,
						},
					});
					const update = {
						_id: propertyId,
						data: {
							imageName: resp.data.image_url,
							propertyDeed: resp.data.deed_url,
						}
					};
					await postDataAPI("updatePropertyFile", update, token);
				} catch (uploadErr) {
					// Upload failed but property was created — still show success
					console.error("File upload failed:", uploadErr);
				}
			}
		}
		dispatch({
			type: PROPERTY_TYPES.CREATE_PROPERTY,
			payload: {
				data: res.data,
			},
		});
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: false } });
	} catch (err) {
		dispatch({
			type: GlobalTypes.NOTIFY,
			payload: {
				error: err?.response?.data?.msg || "Failed to create property",
			},
		});
	}
};

export const editProperty = (data) => async (dispatch, getState) => {
	try {
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: true } });
		const token = getState().auth?.data?.accesstoken || getState().auth?.data?.access_token;
		const res = await postDataAPI("update_property", data, token);
		if(res.data.status==1){
			dialog.success("Updated", "Property updated successfully!");
		}
		dispatch({
			type: PROPERTY_TYPES.CREATE_PROPERTY,
			payload: {
				data: res.data,
			},
		});
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: false } });
	} catch (err) {
		dispatch({
			type: GlobalTypes.NOTIFY,
			payload: {
				error: err?.response?.data?.msg || "Failed to update property",
			},
		});
	}
};

export const blankProperty = () => async (dispatch) => {
	dispatch({
		type: PROPERTY_TYPES.CREATE_PROPERTY,
		payload: {
			data: { status: 0, errors: {}},
		},
	});
};
